import { Box, DialogActions, DialogContent, DialogContentText, Typography } from '@mui/material';
import DialogBaseCC from 'components/Dialog/DialogBaseCC';
import { useTranslation } from 'react-i18next';
import { DIALOG_ID } from './constant';

const DialogLimitAccess = () => {
    const { t } = useTranslation();

    return (
        <DialogBaseCC id={DIALOG_ID.LIMIT_ACCESS} title={t('dialog.limit-access.title')}>
            <DialogContent sx={{ maxWidth: '100% !important' }}>
                <DialogContentText sx={{ maxWidth: '100% !important', display: 'flex', flexDirection: 'column' }}>
                    <Box>
                        {t('dialog.limit-access.content-1')} {t('dialog.limit-access.content-2')}{' '}
                        <Typography
                            sx={{
                                fontWeight: '600',
                                fontStyle: 'italic',
                                color: theme => theme.palette.secondary.main,
                                textDecorationLine: 'underline',
                            }}
                        >
                            {t('dialog.limit-access.content-3')}
                        </Typography>
                        !
                    </Box>
                    <Box>
                        {t('dialog.limit-access.content-4')}{' '}
                        <Typography sx={{ fontWeight: '600', fontStyle: 'italic' }}>
                            {t('dialog.limit-access.content-5')}
                        </Typography>
                        {t('dialog.limit-access.content-6')}
                    </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions></DialogActions>
        </DialogBaseCC>
    );
};

export default DialogLimitAccess;
